import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
export const NotFound = () => {
    const navigate = useNavigate();
    return (_jsx("div", { style: styles.container, children: _jsxs("div", { style: styles.content, children: [_jsx("h1", { style: styles.code, children: "404" }), _jsx("h2", { style: styles.title, children: "Page Not Found" }), _jsx("p", { style: styles.description, children: "The page you're looking for doesn't exist or has been moved." }), _jsx("button", { onClick: () => navigate('/'), style: styles.button, children: "Go Home" })] }) }));
};
const styles = {
    container: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f9fafb',
    },
    content: {
        textAlign: 'center',
        padding: '32px',
    },
    code: {
        fontSize: '96px',
        fontWeight: '700',
        margin: 0,
        color: '#f3f4f6',
        textShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)',
    },
    title: {
        fontSize: '32px',
        fontWeight: '700',
        margin: '16px 0 8px 0',
        color: '#1f2937',
    },
    description: {
        fontSize: '16px',
        color: '#6b7280',
        marginBottom: '32px',
    },
    button: {
        padding: '12px 32px',
        backgroundColor: '#3b82f6',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
    },
};
//# sourceMappingURL=NotFound.js.map